import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getSeguimientoAnonimoGatewayBaseUrl } from '../base/url.seguimiento-anonimo.gateway';
import { AnonymousSessionStorage } from '../jwt/anonymous-session.storage';

/**
 * Añade `Authorization: Bearer` a las peticiones del API Gateway de seguimiento anónimo.
 */
@Injectable()
export class AnonymousGatewayBearerInterceptor implements HttpInterceptor {
  constructor(private readonly session: AnonymousSessionStorage) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const base = getSeguimientoAnonimoGatewayBaseUrl();
    if (!request.url.startsWith(base)) {
      return next.handle(request);
    }
    const token = this.session.getToken();
    if (!token) {
      return next.handle(request);
    }
    if (request.headers.has('Authorization')) {
      return next.handle(request);
    }
    return next.handle(
      request.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      })
    );
  }
}
